export enum LoginFlow {
  EMAIL_PHONE = 'EMAIL_PHONE',
  APPLE = 'APPLE',
  GOOGLE = 'GOOGLE',
}
